// extracted by mini-css-extract-plugin
module.exports = {"root":"classes_root__q6EjS","title":"classes_title__3xRxm","separator":"classes_separator__3-fxt","element":"classes_element__8GOkA"};